import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import { CloseOpportunityErrorModalProps } from './CloseOpportunityErrorModal.types'
import { CloseOpportunityErrorCode } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'

export function CloseOpportunityErrorModal({
  open,
  handleClose,
  errorCode
}: Readonly<CloseOpportunityErrorModalProps>) {
  const { t } = useTranslation()

  const errorCodesMap: Record<CloseOpportunityErrorCode, string> = {
    'opportunity/close_invalid_state': t('errorMessage.closeOpportunity.closeInvalidState'),
    'opportunity/cannot_close_future': t('errorMessage.closeOpportunity.cannotCloseFuture'),
    'opportunity/external': t('errorMessage.closeOpportunity.externalOpportunity')
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <AcknowledgeModal
        result="negative"
        title={t('typography.volunteering.closeOpportunityErrorModal.title')}
        description={errorCodesMap[errorCode] ?? t('errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
